import { getFullName } from "#clockwise/web-commons/src/util/profile.util";
import { Avatar, Chip } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import classnames from "classnames";
import React from "react";
import { styles } from "./person-chip.styles";

const useStyles = makeStyles(styles);

export type Props = {
  email: string;
  isFocused?: boolean;
  name?: {
    givenName?: string | null;
    familyName?: string | null;
  };
  imageUrl?: string | null;
  className?: string;
  onClick?: (key: string) => void;
  onDelete?: (key: string) => void;
  tabIndex?: number;
  disabled?: boolean;
  "data-tag-index"?: string;
};

export const PersonChip = ({
  email,
  name,
  onClick,
  onDelete,
  className,
  tabIndex,
  imageUrl,
  disabled = false,
  // Required data attribute for compatibility with MUI Autocomplete keyboard controls
  "data-tag-index": dataTagIndex,
}: Props) => {
  const classes = useStyles();

  const fullName = getFullName(name);

  const chip = (
    <Chip
      avatar={
        <Avatar alt={fullName} className={classes.avatar} src={imageUrl || undefined}>
          {(fullName && fullName[0]) || (email && email[0]) || null}
        </Avatar>
      }
      label={fullName || email}
      onClick={onClick && (() => onClick(email))}
      onDelete={onDelete && (() => onDelete(email))}
      className={classnames(classes.chip, className)}
      title={fullName !== email ? email : undefined}
      disabled={disabled}
      tabIndex={tabIndex}
      data-tag-index={dataTagIndex}
    />
  );

  return chip;
};
